export
const name: string = "LightingInVs";

export
const preproc: string = ``;

export
const declaration: string = `
    // the light related code was inspired by http://www.john-chapman.net/content.php?id=3
    struct SLight {
              vec4 position; // in view space when the w component is zero, we have directional light
        lowp  vec3 diffuse;
        lowp  vec3 specular;
        lowp  float enabled;
        lowp  float fixed_pos;
    };

    const      int    MAX_LIGHT_SOURCES = 2;

    // required uniforms
    uniform       float  u_minimal_diffuse_light; // for shadow volumes
    uniform       int    u_lights_count;
    uniform       SLight u_lights[MAX_LIGHT_SOURCES];

    uniform mat3    u_normal_mat;
    uniform mat4    u_view_matrix;
    uniform mat4    u_manipulator_light;

    uniform SMaterial   u_material;
`;

export
const varyings: string = `
    varying       vec3   v_diffuse_color;
    varying       vec3   v_specular_color;

    varying       vec3   v_simple_diffuse_color;
    varying       vec3   v_simple_specular_color;
`;

export
const implementation: string = `
    void directional(
        const in int aTwoSidedLighting,
        const in float aShininess,
        const in SLight aLight,
        const in vec3 aSurfaceViewNormal,
        const in vec4 aViewPosition)
    {
        //	get direction to light:
    	vec3 light_direction = normalize(aLight.position.xyz);

        //	accumulate diffuse:
    	float n_dot_l;
    	if (aTwoSidedLighting == 0) {
    	    // one sided lighting
    		n_dot_l = dot(aSurfaceViewNormal, light_direction);
    	}
    	else {
    	    // this is two sided lighting i.e. the direction of the dot product does not matter
    		n_dot_l = abs(dot(aSurfaceViewNormal, light_direction));
    	}

    	v_diffuse_color += aLight.diffuse * max(u_minimal_diffuse_light, n_dot_l);

    	if (n_dot_l > 0.0 && aShininess > 0.00001) { // if fragment is illuminated
    		//	accumulate specular:
    		vec3 view_direction = normalize(aViewPosition.xyz);
    		vec3 reflection = reflect(light_direction, aSurfaceViewNormal);
    		float spec = max(0.0, dot(reflection, view_direction));
            v_specular_color += aLight.specular * pow(spec, aShininess * 100.0);
    	}
    }

    // we need to compute directional lighting and simple not directional (only sum of lights) because we decde the
    // lighting type in fragment shader based on texture mapping
    void setVaryingsForLighting0()
    {
        setVaryingsForLightingCommon0();

        v_diffuse_color = vec3(0.0);
        v_specular_color = vec3(0.0);

        v_simple_diffuse_color = vec3(0.0);
        v_simple_specular_color = vec3(0.0);

        vec3 normal_not_rotated = vec3(0.0);
        vec3 normal             = vec3(0.0);
        vec4 viewPosition       = vec4(0.0);

        for (int i = 0; i < MAX_LIGHT_SOURCES; i++) {
            if (i < u_lights_count) {
                if (u_lights[i].enabled > 0.5) {
                    if (u_lights[i].position.w > 0.5) {
                        /*if (u_lights[i].spot_exponent != 0.0) { // spot light
                            spot(surface, u_lights[i], results);
                        }
                        else { // point light
                            point(surface, u_lights[i], results);
                        }*/
                    }
                    else { //w == 0.0 -> directional light
                        if (u_lights[i].fixed_pos > 0.5) {
                            directional(u_material.two_sided_lighting, 0.2, u_lights[i], normal_not_rotated, viewPosition);
                        }
                        else {
                            directional(u_material.two_sided_lighting, 0.2, u_lights[i], normal, viewPosition);
                        }
                        v_simple_diffuse_color  += u_lights[i].diffuse;
                        v_simple_specular_color += u_lights[i].specular;
                    }
                }
            }
        }
    }

    /**
     * Changed for instancing
     *
     * @param aNormal = a_normal
     * @param aEyeSpacePosition = ManipulatorTrafo * vec4(a_position * scale + a_offset, 1.0) ... modelMatrix * vertex
     * @param aClipSpacePosition = ProjectionMatrix * ViewMatrix * aEyeSpacePosition
     */
    void setVaryingsForLighting2(in vec3 aNormal, in vec4 aEyeSpacePosition, in vec4 aClipSpacePosition)
    {
        setVaryingsForLightingCommon2(aNormal, aEyeSpacePosition, aClipSpacePosition);

        v_diffuse_color = vec3(0.0);
        v_specular_color = vec3(0.0);

        v_simple_diffuse_color = vec3(0.0);
        v_simple_specular_color = vec3(0.0);

        vec3 normal_not_rotated = normalize(aNormal);
        vec3 normal = u_normal_mat * normal_not_rotated;
    #ifdef MANIPULATOR_ENABLED
        // change normals because of the manipulator transformation
        if (a_manipulation > 0.5) {
            normal_not_rotated = mat3(u_manipulator_light) * normalize(aNormal);
            normal = u_normal_mat * mat3(u_manipulator) * mat3(u_manipulator_light) * normal_not_rotated;
        }
    #endif

        // View * Model * Vertex
        vec4 viewPosition  = u_view_matrix * aEyeSpacePosition;

        for (int i = 0; i < MAX_LIGHT_SOURCES; i++) {
            if (i < u_lights_count) {
                if (u_lights[i].enabled > 0.5) {
                    if (u_lights[i].position.w > 0.5) {
                        /*if (u_lights[i].spot_exponent != 0.0) { // spot light
                            spot(surface, u_lights[i], results);
                        }
                        else { // point light
                            point(surface, u_lights[i], results);
                        }*/
                    }
                    else { //w == 0.0 -> directional light
                        if (u_lights[i].fixed_pos > 0.5) {
                            directional(u_material.two_sided_lighting, 0.2, u_lights[i], normal_not_rotated, viewPosition);
                        }
                        else {
                            directional(u_material.two_sided_lighting, 0.2, u_lights[i], normal, viewPosition);
                        }
                        v_simple_diffuse_color  += u_lights[i].diffuse;
                        v_simple_specular_color += u_lights[i].specular;
                    }
                }
            }
        }
    }
`;
